import axios from 'axios';
import {
    CSRFTokenResponse,
    InquirySubmit
  } from './models';

export const wlApi = axios.create({
    baseURL: '/api'
});

/**
 * リクエストに含めるCSRFトークンを設定します。
 * @param token - CSRFトークン
 */
export function setCSRFToken(token: string) {
    wlApi.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

/**
 * リクエストに含めるCSRFトークンを削除します。
 */
export function clearCSRFToken() {
    delete wlApi.defaults.headers.common['X-CSRF-TOKEN'];
}

/**
 * CSRFトークンを作成します。
 * @returns CSRFトークン
 */
export async function createCSRFToken(): Promise<string> {
    const response = await wlApi.post<CSRFTokenResponse>('/csrf_token');
    return response.data.csrfToken;
}

/**
 * お問い合わせを作成します。
 * @param inquiry - お問い合わせ情報
 */
export async function createInquiry(inquiry: InquirySubmit): Promise<void> {
    await wlApi.post('/inquiries', inquiry);
}
